import ValidationError from "@/components/form/ValidationError";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import { FormRadio } from "../../form/FormRadio";
import ValidatedField from "../../form/ValidatedField";
import { RevisorsSectionProps } from "../RevisorsErklaering";

export default function Revisors0Intro(props: RevisorsSectionProps) {
  const { texts, isCompleteHelpers, formikProps, refs, locked } = props;
  const { touched, errors, values } = formikProps;
  const {
    revisors_header,
    revisors_prof_etik,
    revisors_revisors_ansvar,
    revisors_advokatens_ansvar,
    revisors_arbhandlinger_og_observationer,
    revisors_formaal,
  } = texts;

  return (
    <AccordionItem value="Indledning">
      <AccordionHeader
        ref={refs.introRef}
        sectionStarted={
          !!values.revisors_0_intro_overholder_revisorloven ||
          !!values.revisors_0_intro_aftalebrev_indgået
        }
        sectionComplete={isCompleteHelpers.revisors_0_intro_complete}
      >
        {revisors_header}
      </AccordionHeader>
      <AccordionBody>
        <div className="vstack gap-2">
          <h4 className="display-4 fw-medium mb-2">
            {revisors_formaal.header1}
          </h4>
          <h4>{revisors_formaal.header2}</h4>
          <p>{revisors_formaal.p1}</p>
          <p>{revisors_formaal.p2}</p>
          <h4>{revisors_advokatens_ansvar.header}</h4>
          <p>{revisors_advokatens_ansvar.p1}</p>
          <p>{revisors_advokatens_ansvar.p2}</p>
          <h4>{revisors_revisors_ansvar.header}</h4>
          <p>{revisors_revisors_ansvar.p1}</p>
          <p>{revisors_revisors_ansvar.p2}</p>
          <p>{revisors_revisors_ansvar.p3}</p>
          <h5>{revisors_prof_etik.header}</h5>
          <p>{revisors_prof_etik.p1}</p>
          <fieldset
            className="vstack gap-1 px-1 mb-3 position-relative"
            disabled={locked}
          >
            <FormRadio
              name={
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven.id
              }
              value={
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven
                  .overholderIkkeRevisorloven.value
              }
              invalid={
                errors.revisors_0_intro_overholder_revisorloven &&
                touched.revisors_0_intro_overholder_revisorloven
                  ? true
                  : false
              }
            >
              {
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven
                  .overholderIkkeRevisorloven.label
              }
            </FormRadio>
            <FormRadio
              name={
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven.id
              }
              value={
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven
                  .overholderRevisorloven.value
              }
              invalid={
                errors.revisors_0_intro_overholder_revisorloven &&
                touched.revisors_0_intro_overholder_revisorloven
                  ? true
                  : false
              }
            >
              {
                revisors_prof_etik.revisors_0_intro_overholder_revisorloven
                  .overholderRevisorloven.label
              }
            </FormRadio>

            <ValidationError
              style={{ top: "100%" }}
              error={errors.revisors_0_intro_overholder_revisorloven}
              show={
                touched.revisors_0_intro_overholder_revisorloven ? true : false
              }
            />
          </fieldset>
          <p>{revisors_prof_etik.p2}</p>
          <h4>{revisors_arbhandlinger_og_observationer.header}</h4>
          <p>
            {revisors_arbhandlinger_og_observationer.textBeforeDatepicker}
            <ValidatedField
              touched={touched.revisors_0_intro_aftalebrev_indgået}
              error={errors.revisors_0_intro_aftalebrev_indgået}
              type="date"
              name={revisors_arbhandlinger_og_observationer.datepickerId}
              additionalClasses=""
              wrapper
              wrapperAdditionalClasses="d-inline-block w-auto mx-2 my-1"
              locked={locked}
            />
            {revisors_arbhandlinger_og_observationer.textAfterDatepicker}
          </p>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
}
